export default "__VITE_ASSET__qGHs1fAT__"